module.exports = __webpack_public_path__ + "static/media/58345A.51f9d848.jpg";